document.addEventListener('DOMContentLoaded', function () {
  var progressBar = document.querySelector('.product-progress');
  var currentDot = document.querySelector('.slider-counter--current').textContent.trim();
  var dots = document.querySelector('.slider-counter--total').textContent.trim();
  // Subtract 1 from dots for calculation
  var calc = (parseFloat(currentDot) / (parseFloat(dots) - 1)) * 100;
  progressBar.style.backgroundSize = calc + '% 100%';
  progressBar.setAttribute('aria-valuenow', calc);

  document.querySelector('.custom-media-desktop .slider--mobile').addEventListener('scroll', function () {
    var currentDot = document.querySelector('.slider-counter--current').textContent.trim();
    var dots = document.querySelector('.slider-counter--total').textContent.trim();
    // Subtract 1 from dots for calculation
    var calc = (parseFloat(currentDot) / (parseFloat(dots) - 1)) * 100;
    progressBar.style.backgroundSize = calc + '% 100%';
    progressBar.setAttribute('aria-valuenow', calc);
  });
});

